import React, { useContext } from 'react';
import Table from './Table';
import Pagination from './Pagination';
import { TableContext } from '../../contexts/TableContext';

const Layout: React.FC = () => {
  const { headerSection, footerSection, pagination } = useContext(TableContext);

  return (
    <div className="card">
      <div className="card-datatable table-responsive">
        <div className="dataTables_wrapper dt-bootstrap5 no-footer">
          <div className="row">{headerSection && headerSection}</div>
          <Table />
          {pagination && <Pagination />}
        </div>
      </div>
      {footerSection && footerSection}
    </div>
  );
};

export default Layout;
